import { render } from "./CrStepSurface2Content.vue?vue&type=template&id=2cd4da68&scoped=true"
import script from "./CrStepSurface2Content.vue?vue&type=script&lang=js"
export * from "./CrStepSurface2Content.vue?vue&type=script&lang=js"

import "./CrStepSurface2Content.vue?vue&type=style&index=0&id=2cd4da68&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd4da68"]])

export default __exports__